export const NAV_EXTERNALS = {
  cypressLocationReplace: (url) => {
    if (window.cypressLocationReplace) {
      window.cypressLocationReplace(url);
    }

    window.location.replace(url);
  },
};
